import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLicenceActionDetailsAsync,
  ILicenceActionDetails,
} from "../../api/ILicensingAction";
import { RootState } from "../store";

export interface LicenceActionState {
  fetchStatus: string;
  licenceAction?: ILicenceActionDetails;
}

const initialState: LicenceActionState = {
  fetchStatus: "Loading...",
  licenceAction: undefined,
};

export const loadLicenceActionAsync = createAsyncThunk(
  "licenceAction/load",
  async (licenceActionId: string) => {
    const response = await GetLicenceActionDetailsAsync(licenceActionId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const licenceActionSlice = createSlice({
  name: "licenceAction",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLicenceActionAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLicenceActionAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licenceAction = action.payload;
      });
  },
});

export const selectLicenceAction = (state: RootState) => state.licenceAction;

export default licenceActionSlice.reducer;
